// extracted by mini-css-extract-plugin
module.exports = {"modalDialog":"ResizeTool_modalDialog__xj7yJ","modalOverlay":"ResizeTool_modalOverlay__hRR1K"};